/** 
 * @file src/App.js
 * @description Module: src/App.js
 *
 * Notes:
 * - This codebase intentionally uses small, framework-agnostic DOM templates (no JSX).
 * - Keep functions pure where possible and keep side-effects (DOM mutations / fetch) explicit.
 */

import Navbar from "./components/Navbar.js";
import Footer from "./components/Footer.js";
import HomePage from "./pages/HomePage.js";

import { AuthStore } from "./services/api.js";
/**
 * Simple client-side router. Clears the main content area and lazy-loads pages on demand.
 */

function navigateTo(page) {
  const content = document.querySelector(".content");
  content.innerHTML = "";

  switch (page) {
    case "home":
      content.appendChild(HomePage());
      break;

    case "about":
      import("./pages/AboutPage.js")
        .then((module) => {
          content.innerHTML = module.default(); // ✅ HTML string
        })
        .catch((error) => console.error("Failed to load AboutPage:", error));
      break;

    case "library":
      import("./pages/LibraryPage.js")
        .then((module) => {
          content.innerHTML = module.LibraryPage(); // ✅ HTML string
          module.setupLibrary();
        })
        .catch((error) => console.error("Failed to load LibraryPage:", error));
      break;

    case "login":
      import("./pages/LoginPage.js")
        .then((module) => {
          content.appendChild(module.LoginPage()); // ✅ DOM element
          module.setupLogin();
        })
        .catch((error) => console.error("Failed to load LoginPage:", error));
      break;

    case "register":
      import("./pages/RegisterPage.js")
        .then((module) => {
          content.appendChild(module.RegisterPage()); // ✅ DOM element
          module.setupRegister();
        })
        .catch((error) => console.error("Failed to load RegisterPage:", error));
      break;

    default:
      content.appendChild(HomePage());
  }
}

// ✅ Updated toggleMenu to handle icon animation
/**
 * Toggles the mobile navigation menu visibility.
 */
function toggleMenu(icon) {
  icon.classList.toggle("active");
  const navLinks = document.querySelector(".nav_links");
  navLinks.classList.toggle("active");
}

/**
 * Re-renders the navbar. Call after login/logout.
 */
function refreshNavbar() {
  const navbarRoot = document.getElementById("navbar-root");
  if (navbarRoot) navbarRoot.innerHTML = Navbar();
}
/**
 * Renders the root layout and navigates to the default page.
 */

const App = () => {
  document.getElementById("root").innerHTML = `
    <div id="navbar-root">${Navbar()}</div>
    <div class="content"></div>
    <div id="footer-root">${Footer()}</div>
  `;
  navigateTo("home");
};

// ✅ Expose globally
window.navigateTo = navigateTo;
window.toggleMenu = toggleMenu;
window.refreshNavbar = refreshNavbar;

window.logout = () => {
  AuthStore.clearSession();
  refreshNavbar();
  navigateTo("home");
};

export default App;
